/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Auth_Email_Token_ExpiredInputs */



/**
* | output |
* | --- |
* | "The email token has expired. Please request a new one." |
*
* @param {Auth_Email_Token_ExpiredInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const auth_email_token_expired = /** @type {((inputs?: Auth_Email_Token_ExpiredInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Auth_Email_Token_ExpiredInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Der E-Mail-Token ist abgelaufen. Bitte fordere einen neuen an.")
	return /** @type {LocalizedString} */ ("The email token has expired. Please request a new one.")
});